import clsx from 'clsx';
import * as React from 'react';
import './wizard-steps.scss';
import { Nav } from 'react-bootstrap';

type NavItemProps = {
  disabled: boolean;
  reached: boolean;
  index: number;
  activeStep: number;
  label: string;
  onSelectStep: (targetStep: number) => void;
};
const NavItem = ({
  index,
  activeStep,
  onSelectStep,
  label,
  reached,
  disabled,
}: NavItemProps) => {
  const isDone = index < activeStep;
  const isActive = !isDone && activeStep === index;
  return (
    <Nav.Item>
      <Nav.Link
        className={clsx({
          'cursor-default': !isDone && !reached,
          'disabled': disabled,
          'done': isDone,
          'active': isActive,
        })}
        onClick={isDone || reached ? () => onSelectStep(index) : undefined}
      >
        <span className='nav-item-circle-parent'>
          <span className={clsx('nav-item-circle')}>{index + 1}</span>
        </span>
        <span className='d-none d-md-block mt-1 fs-xs'>{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

type Props = {
  steps: Array<{
    id: string;
    label: string;
    disabled?: boolean;
  }>;
  activeStep: number;
  onSelectStep: (step: number) => void;
};

const WizardSteps = ({ steps, activeStep, onSelectStep }: Props) => {
  const [visitedSteps, setVisitedSteps] = React.useState<
    Record<number, boolean>
  >({});

  return (
    <div className='theme-wizard'>
      <Nav className='justify-content-center'>
        {steps.map((step, index) => (
          <NavItem
            key={step.id}
            index={index}
            activeStep={activeStep}
            onSelectStep={(targetStep) => {
              onSelectStep(targetStep);
              setVisitedSteps((prev) => ({ ...prev, [targetStep]: true }));
            }}
            label={step.label}
            disabled={Boolean(step.disabled)}
            reached={Boolean(visitedSteps[index])}
          />
        ))}
      </Nav>
    </div>
  );
};

export default WizardSteps;
